import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export function SiteVisitSection({ formData, handleChange }) {
  const showSiteVisit = ['site_visit_scheduled', 'site_visit_completed', 'in_negotiation', 'closed_won'].includes(formData.status);
  
  if (!showSiteVisit) return null;

  return (
    <div className="border-t pt-6">
      <h3 className="text-lg font-semibold text-slate-800 mb-4">Site Visit Details</h3>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div>
          <Label>Site Visit Date</Label>
          <Input type="date" name="site_visit_date" value={formData.site_visit_date} onChange={handleChange} className="mt-1 h-11 rounded-sm" data-testid="lead-site-visit-date" />
        </div>
        <div>
          <Label>Location</Label>
          <Input name="site_visit_location" value={formData.site_visit_location} onChange={handleChange} placeholder="Site address" className="mt-1 h-11 rounded-sm" />
        </div>
        <div>
          <Label>Feedback</Label>
          <select name="site_visit_feedback" value={formData.site_visit_feedback} onChange={handleChange} className="mt-1 h-11 w-full rounded-sm border border-slate-200 bg-white px-3 text-sm">
            <option value="">Select</option>
            <option value="interested">Interested</option>
            <option value="need_time">Need Time</option>
            <option value="not_suitable">Not Suitable</option>
          </select>
        </div>
      </div>
    </div>
  );
}
